module.exports = __webpack_public_path__ + "static/media/icon_f.d1a607fa.svg";